import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { getOverallCount } from "../services/core";

const OverallCountContext = createContext();

export const OverallCountProvider = ({ children }) => {
  const token = localStorage.getItem("access_token");
  const [overallCount, setOverallCount] = useState({});
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const [err, data] = await getOverallCount();
      if (!err && data) {
        setOverallCount(data);
      }
    } catch (e) {
      console.error("Error fetching overall count:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  // fetch once on mount
  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <OverallCountContext.Provider value={{ overallCount, loading, refresh }}>
      {children}
    </OverallCountContext.Provider>
  );
};

export const useOverallCount = () => useContext(OverallCountContext);
